import React from "react";
import { Modal, Model, Button, Input, message } from 'antd';
import dayjs from "dayjs";
import Remarks from './remarks';

export default ({ children, ...others }) => {
    const open = () => {
        const m = Modal.info({
            icon: null,
            closable: true,
            title: others.title || '备注',
            content: <Remarks {...others} onChange={() => {
                m.destroy();
                others?.onChange?.();
            }} />,
            footer: null,
        });
    }

    return <span>
        {children || <a onClick={open}>更多</a>}
    </span>
}